import { useState } from 'react'
import stylesC from '../../styles/common.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import { Link } from 'react-router-dom';
import { KR } from '../../constants/localizations';
import { ICONPATH } from '../../constants/iconPath';


export default function Header() {

    const [isOpen, setIsOpen] = useState(false);

    const handleNav = () => {
        setIsOpen(!isOpen);
    }

    return (
        <header className={stylesC.headerWrap}>
            <div className={stylesC.header}>
                <div className={stylesC.logoWrap}>
                    <Link to="/">
                        <img src={IMAGEPATH.logo} alt="ar247_logo" />
                    </Link>
                </div>
                <div onClick={handleNav} className={stylesC.hamburger}>
                    <img src={ICONPATH.nav} alt="nav" />
                </div>
                <nav className={isOpen ? stylesC.show : ''}>
                    <div onClick={handleNav}>
                        <img src={ICONPATH.close} alt="close" />
                    </div>
                    <Link to="/" onClick={handleNav}>
                        <span>{KR.label_header_home}</span>
                    </Link>
                    <Link to="/company" onClick={handleNav}>
                        <span>{KR.label_header_company}</span>
                    </Link>
                    <Link to="/solution" onClick={handleNav}>
                        <span>{KR.label_header_solution}</span>
                    </Link>
                    <Link to="/products" onClick={handleNav}>
                        <span>{KR.label_header_product}</span>
                    </Link>
                </nav>
            </div>
        </header>
    )
}
